<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="4" class="bg-primary-transparent">
          <v-container v-if="!loading_purchases_data">
            <v-row justify="space-between">

              <!-- Ventas netas -->
              <v-col cols="12" class="text-center">
                <v-row class="ma-0" justify="center">
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <div class="font-weight-bold color-black">Costo General</div>
                  </v-col>
                  <v-col cols="12" sm="12" xs="12" md="12">
                    <h4 class="display-2 primary--text">{{ cost | toFix2 | sufix('%') }}</h4>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <loader :loading="loading_purchases_data"></loader>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="8" class="px-5">
          <v-container v-if="!loading_purchases_data">
            <line-chart
              :chart-data="costData"
              :options="{
                responsive: true,
                maintainAspectRatio: false
              }"
            />
          </v-container>
          <loader :loading="loading_purchases_data"></loader>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" class="mt-10">
          <v-container fluid>
            <v-row jusfity="center">
              <v-col cols="12" md="6" class="pl-0 pt-0">

                <v-container>
                  <v-row justify="space-between" class="fill-height">

                    <v-col cols="12" class="text-left pa-0">
                      <v-row class="ma-0" no-gutters justify="center">
                        <v-col cols="12" sm="12" xs="12" md="12">
                          <h4 class="font-weight-regular primary--text">Compras</h4>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12">
                      <v-row class="ma-0" justify="center" v-if="!loading_purchases">
                        <v-col cols="12" sm="12" xs="12" md="12">
                          <v-container>
                            <v-row justify="space-between">
                              <v-col cols="12" md="6" :class="['pa-0']" style="position: relative" v-for="area in areasAndRefunds" :key="area.id">
                                <v-row class="ma-0 fill-height">
                                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                                    <div class="font-weight-bold color-black">{{ area.name }}</div>
                                  </v-col>
                                  <v-col cols="12" sm="12" xs="12" md="12">
                                    <div :class="['subtitle-1', { 'red--text': area.id === 'refund' && purchases_total(area) }]">
                                      {{ purchases_total(area) | toFixNumber(2) | numberWithComma | prefix('$') }}
                                      <v-tooltip
                                        v-if="area.id === 'refund'"
                                        top
                                        max-width="300">
                                        <template v-slot:activator="{ on }">
                                          <v-btn x-small icon v-on="on">
                                            <v-icon color="dark-grey">mdi-information</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>
                                          Las compras que se han aplicado devolución, puedes revisarlas en la tabla de movimientos.
                                        </span>
                                      </v-tooltip>
                                    </div>
                                  </v-col>
                                  <v-btn
                                    :to="{
                                      name: 'purchases',
                                      params: { id: area.id },
                                      query: {
                                        dates: dates,
                                        period: period
                                      }
                                    }"
                                    v-if="area.id !== 'refund'"
                                    absolute
                                    right fab small style="right: 5%">
                                    <v-icon>mdi-chevron-right</v-icon>
                                  </v-btn>
                                </v-row>
                              </v-col>

                            </v-row>
                          </v-container>
                        </v-col>
                      </v-row>

                      <loader :loading="loading_purchases"></loader>
                    </v-col>
                  </v-row>

                </v-container>
              </v-col>

              <!-- <v-col cols="12" md="6" class="pl-0 pt-0 report-big-half-container-1">
                <v-container fluid>
                  <v-row justify="space-between" class="fill-height">

                    <v-col cols="12" md="12" class="text-left pa-0">
                      <v-row class="ma-0" no-gutters justify="center">
                        <v-col cols="12" md="12">
                          <h4 class="font-weight-regular primary--text pl-5">Inventario</h4>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" md="12" class="text-center">
                      <v-row class="ma-0" justify="center">
                        <v-col cols="12" md="12">

                          <v-container>
                            <v-row justify="space-between">

                              <v-col cols="12" md="6" class="text-center pa-0" style="position: relative" v-for="area in areas" :key="area.id">
                                <v-row class="ma-0 fill-height" justify="center">
                                  <v-col cols="12" sm="12" xs="12" md="12" class="pb-0">
                                    <div class="font-weight-bold color-black">{{ area.name }}</div>
                                  </v-col>
                                  <v-col cols="12" sm="12" xs="12" md="12">
                                    <h6 class="text-h6">$203,078.00</h6>
                                  </v-col>
                                  <v-btn :to="{ name: 'inventory', params: { id: area.id } }" absolute right fab small style="right: -5px"><v-icon>mdi-chevron-right</v-icon></v-btn>
                                </v-row>
                              </v-col>

                            </v-row>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col> -->
            </v-row>

          </v-container>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import api from '@/api/reports'
import { mapGetters } from 'vuex'
import LineChart from './purchases/charts/LineChart'
import Loader from '@/components/Loader'

export default {
  name: 'purchases-reports',
  components: {
    LineChart,
    Loader
  },
  props: {
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      purchases: [],
      loading_purchases: false,
      loading_purchases_data: false,
      loading: false,
      purchases_data: null
      // cost: 0
    }
  },
  computed: {
    ...mapGetters({
      restaurant: 'restaurant',
      areas: 'areas',
      cost: 'currentRestaurant/reports/totalCost',
      batchCosts: 'currentRestaurant/reports/batchCostByArea'
    }),
    areasAndRefunds: function () {
      const areas = this.areas || []
      // look if there is a refund area if not add it
      const refunArea = areas.find(area => area.id === 'refund')
      if (!refunArea) {
        areas.push({
          id: 'refund',
          name: 'Devoluciones'
        })
      }
      return areas
    },
    costData: function () {
      const result = this.batchCosts.reduce((acc, curr) => {
        acc.labels.push(curr.date)
        curr.result.forEach(c => {
          const index = acc.datasets.findIndex(d => d.label === c.areaName)
          if (index < 0) {
            acc.datasets.push({
              label: c.areaName,
              borderColor: '#' + ((1 << 24) * Math.random() | 0).toString(16),
              fill: false,
              data: [c.cost]
            })
          } else {
            acc.datasets[index].data.push(c.cost)
          }
        })
        return acc
      }, {
        labels: [],
        datasets: []
      })
      // .forEach(c => {
      //   labels.push(c.date)
      //   c.result.forEach(r => {
      //     data.push({
      //       label: r.areaName,
      //       borderColor: '#' + ((1 << 24) * Math.random() | 0).toString(16),
      //       fill: false,
      //       data: r.total
      //     })
      //   })
      // })
      return result
      // label: area.area,
      // borderColor: '#' + ((1 << 24) * Math.random() | 0).toString(16),
      // fill: false,
      // data: totals

      // labels: dates,
      // datasets: data
    }
  },
  async created () {
    await this.getPurchases()
    await this.getPurchasesChartsArea()
    // await this.getFinances()
  },
  watch: {
    dates: function (value) {
      if (value.length >= 2) this.getPurchases()
      if (value.length >= 2) this.getPurchasesChartsArea()
      // if (value.length >= 2) this.getFinances(value)
    }
  },
  methods: {
    getRandInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },

    async getPurchasesChartsArea () {
      let [ fromDate ] = this.dates
      this.loading_purchases_data = true
      try {
        await this.$store.dispatch('currentRestaurant/reports/getBatchSales', {
          date: fromDate,
          type: this.period
        })
        await this.$store.dispatch('currentRestaurant/reports/getBatchPurchases', {
          date: fromDate,
          type: this.period
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading_purchases_data = false
    },

    /**
     * Método para obtener los datos de las compras de Cocina y Barra
     */
    async getPurchases () {
      let [ fromDate ] = this.dates
      this.loading_purchases = true
      try {
        const purchasesByArea = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/purchases-by-area`, {
          date: fromDate,
          type: this.period
        })
        this.purchases = purchasesByArea.map(purchase => {
          if (purchase.area === 'refund') {
            purchase.area = {
              id: 'refund',
              name: 'Devoluciones'
            }
          }
          return purchase
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading_purchases = false
    },

    purchases_total (area) {
      return (this.purchases.find(pa => pa.area === area._id) || {}).total || 0
    },
    purchases_percent (area) {
      return (this.purchases.find(pa => pa.name === area) || {}).percent || 0
    },

    getFinances (dates = []) {
      let [ fromDate, toDate ] = dates
      this.loading = true
      api.finance({ restaurant: this.restaurant._id, from_date: fromDate, to_date: toDate })
        .then(resp => resp.json())
        .catch(error => {
          this.$toasted.show(error.message, { duration: 3000 })
        })
        .then(response => {
          if (response.data) {
            if (response.data.sales !== 0) {
              this.cost = ((response.data.purchases / response.data.sales) * 100)
            } else {
              this.cost = 0
            }
          }
        }).finally(() => (this.loading = false))
    }
  }
}
</script>
